export const MAX_INPUT_LENGTH = 400;
export const BIO_MAX_LENGTH = 600;
